import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-container" }
const _hoisted_3 = { class: "footer-content" }
const _hoisted_4 = { class: "footer-section" }
const _hoisted_5 = { class: "footer-text" }
const _hoisted_6 = { class: "footer-links" }

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FooterComponent',
  setup(__props) {

const currentYear = computed(() => new Date().getFullYear())

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, " © " + _toDisplayString(currentYear.value) + " CodePod Ariel Podzorski. Alle Rechte vorbehalten. ", 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/impressum",
            class: "footer-link"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode(" Impressum ", -1)
            ])),
            _: 1,
            __: [0]
          }),
          _createVNode(_component_router_link, {
            to: "/datenschutz",
            class: "footer-link"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Datenschutz ", -1)
            ])),
            _: 1,
            __: [1]
          })
        ])
      ])
    ])
  ]))
}
}

})